import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { ImageContainer, ImageName, cardShimmerStyle } from './ImageCardStyles';

const ImageContainerSkeleton = styled(ImageContainer)`
  ${cardShimmerStyle}
  justify-content: end;
`;

const ImageNameSkeleton = styled(ImageName)`
  height: 32px;
`;

export const ImageCardSkeleton = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <ImageContainerSkeleton ref={ref}>
      <ImageNameSkeleton />
    </ImageContainerSkeleton>
  );
});
